"use client";

import { usePathname } from "next/navigation";
import Header from "@/components/header/header";
import FooterWrapper from "@/components/layout/FooterWrapper";
import ClientOnly from "./ClientOnly";

export default function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // pages where header/footer should be hidden
  const hideLayout = pathname.startsWith("/admin") || pathname === "/login";

  return (
    <>
      {!hideLayout && (
        <ClientOnly>
          <Header />
        </ClientOnly>
      )}
      {children}
      {!hideLayout && <FooterWrapper />}
    </>
  );
}
